import { UserAvatar } from "@/components/shared";
import { ChatMessageWithMentions } from "@/components/shared/mentions";
import { Card } from "@/components/ui/card";
import { ChatMessage, User, UserOnEntity } from "@/graphql/__generated__/graphql";
import { formatDateLocale } from "@/utils/helpers";
import { useIntl } from "react-intl";
import { cn } from "@/lib/utils";

interface Props {
  chatMessage: ChatMessage;
  isCurrentUserMessage: boolean;
  tenderUsers: UserOnEntity[];
};

/**
 * Chat bubble component
 * @param chatMessage - ChatMessage
 * @param isCurrentUserMessage - boolean
 * @param tenderUsers - User[]
 * @returns JSX.Element
 */
function ChatBubble({ chatMessage, isCurrentUserMessage, tenderUsers }: Props) {

  // Hooks
  const intl = useIntl();

  return (
    <Card className="flex flex-col gap-2 p-2 min-w-[30%] max-w-[70%]">
      <div className={cn("flex gap-2 items-center", isCurrentUserMessage && "flex-row-reverse")}>
        <UserAvatar user={chatMessage.user as User} showTitle={true} />
        <div className={cn("text-xs", isCurrentUserMessage ? "text-green-600" : "text-blue-600")}>
          {chatMessage.user?.firstname} {chatMessage.user?.lastname}
        </div>
        <span className="text-xs text-slate-500">-</span>
        <div className="text-xs text-slate-500">
          {chatMessage.user?.organization?.shortName}
        </div>
      </div>
      <div>
        <div className="text-sm whitespace-pre-line">
          {ChatMessageWithMentions(chatMessage.text, tenderUsers)}
        </div>
      </div>
      <div className="flex justify-end">
        <p className="text-xs text-slate-500">
          {formatDateLocale(intl, chatMessage.createdAt, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })}
        </p>
      </div>
    </Card>
  );
}

export default ChatBubble;
